<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .share-header {
    align-items: center;
    background: colors.get(interfaceSwGrey_4);
    border-radius: utils.in_rem(8px);
    display: flex;
    justify-content: space-between;
    padding: 0 utils.in_rem(4px) 0 utils.in_rem(12px);

    .resume-type {
      @include mixins.body2();
      @include colors.color(textDisabledGrey);
      align-items: center;
      display: flex;
      gap: utils.in_rem(8px);

      .separator {
        @include colors.background-color(interfaceSwGrey_10);
        width: utils.in_rem(1px);
        height: utils.in_rem(14px);
      }
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { formatDateWithOrdinal } from "../../../../../utils/time";
  import {
    activePopUpModalStore,
    candidateFilesStore,
    candidateStore,
    selectedBackgroundTabStore,
  } from "../../stores";

  let resumeFile = $derived(
    $candidateFilesStore?.find(
      (file) => file.fileId == $candidateStore.resumeFileId
    )
  );

  const formatDate = (timestamp) =>
    timestamp
      ? formatDateWithOrdinal(timestamp, {
          includeComma: true,
        })
      : "";

  const openShareResumeModal = () => {
    activePopUpModalStore.set({
      modal: "shareResume",
    });
  };
</script>

<div class="share-header">
  <span class="resume-type">
    {#if $selectedBackgroundTabStore === "linkedin"}
      Linkedin Resume
    {:else if resumeFile}
      <span>{resumeFile.filename}</span>
      <span class="separator"></span>
      <span>Last updated: {formatDate(resumeFile.timestamp)}</span>
    {:else}
      Resume
    {/if}
  </span>
  <Button
    kind="ghost-blue"
    size="small"
    trailingIcon="fa-arrow-right"
    onclick={openShareResumeModal}>Share resume</Button
  >
</div>
